<div class="alain-default__nav-item" nz-dropdown nzPlacement="bottomCenter" [nzDropdownMenu]="aiMenu">
  <button type="button" class="hidden-mobile" aria-label="Open Quinny AI"
    style="border: 0; background: transparent; padding: 0; cursor: pointer;" (click)="openQuinnyAI($event)">
    <img src="https://cdn.qne.cloud/qca/assets/img/quinny-ai-logo.webp" alt=""
      class="chat-icon" width="120" height="35" />
  </button>
  <button type="button" class="hidden-pc" aria-label="Open Quinny AI"
    style="border: 0; background: transparent; padding: 0; cursor: pointer;" (click)="openQuinnyAI($event)">
    <img [src]="quinnyAiAvatarUrl" alt="" class="chat-icon" width="25" height="25" />
  </button>
</div>

<nz-dropdown-menu #aiMenu="nzDropdownMenu" nzTheme="dark">
  <ul nz-menu nzTheme="dark">
    <li nz-menu-item (click)="navigateToAI('/ai/copilot')">
      <span>Quinny AI</span>
      <span class="badge">Beta</span>
    </li>
    <li nz-menu-item [nzDisabled]="!canViewReportCenter" nz-tooltip
      [nzTooltipTitle]="!canViewReportCenter ? noPermissionTip : ''" nzTooltipPlacement="left"
      (click)="canViewReportCenter && navigateToAI('/ai/report-analyzer')">
      <span>Quinny AI Report Analyzer</span>
      <span class="badge">Beta</span>
    </li>
    <li nz-menu-item [nzDisabled]="!canViewReportDesigner" nz-tooltip
      [nzTooltipTitle]="!canViewReportDesigner ? noPermissionTip : ''" nzTooltipPlacement="left"
      (click)="canViewReportDesigner && navigateToAI('/ai/report-designer')">
      <span>Quinny AI Report Designer</span>
      <span class="badge">Beta</span>
    </li>
    <li nz-menu-item (click)="navigateToAI('/ai/financial-advisor')">
      <span>Quinny AI Financial Advisor</span>
    </li>
    <!-- <li nz-divider></li>
    <li nz-menu-item (click)="openChat()">
      <span nz-icon nzType="message" nzTheme="outline"></span>
      <span>AI Support Chat</span>
    </li> -->
  </ul>
</nz-dropdown-menu>